// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2b2Lo","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1WiYH"};